import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { requestAuthCode, verifyAuthCode } from '../../api/constlink';
import VerifyUserPhone from '../../components/auth/VerifyUserPhone';
import { RootState } from '../../modules';
import { updateUserAsync, UserParams } from '../../modules/auth';

function UpdateUserPhoneContainer({ history, match }: RouteComponentProps) {
  const user = useSelector((state: RootState) => state.auth.auth.data);
  const dispatch = useDispatch();
  const [authCode, setAuthCode] = useState<any>(null);
  const [verifiedAuthCode, setVerifiedAuthCode] = useState<any>(null);

  const goBack = () => {
    history.goBack();
  };

  const _requestAuthCode = async (data: any) => {
    try {
      await requestAuthCode({ data });
      setAuthCode({ message: '인증코드를 요청하였습니다.', type: 'success' });
    } catch (error) {
      setAuthCode({
        message: '인증코드 요청을 실패 하였습니다.',
        type: 'danger',
      });
    }
  };

  const _verifyAuthCode = async (data: any) => {
    try {
      await verifyAuthCode({ data });
      setVerifiedAuthCode({
        message: '휴대전화 인증 성공 하였습니다.',
        type: 'success',
      });
    } catch (error) {
      setVerifiedAuthCode({
        message: '휴대전화 인증 실패 하였습니다.',
        type: 'danger',
      });
    }
  };

  const _updateUserPhone = (data: any) => {
    const params: UserParams = {
      user: {
        ...user,
        personalPhone: data,
      },
    };
    dispatch(updateUserAsync.request(params));
    history.goBack();
  };

  return (
    <>
      <div style={{ marginTop: '50px' }}>
        <VerifyUserPhone
          authCode={authCode}
          verifiedAuthCode={verifiedAuthCode}
          successBtnMsg={'변경하기'}
          requestAuthCode={_requestAuthCode}
          verifyAuthCode={_verifyAuthCode}
          onPrev={goBack}
          updateUserPhone={_updateUserPhone}
        />
      </div>
    </>
  );
}

export default UpdateUserPhoneContainer;
